module.exports = __webpack_public_path__ + "img/home_first_banner@2x.751332dc.jpg";